import { configureStore } from "@reduxjs/toolkit";
import cartSlice from "./cartSlice";
import userDataSlice from "./userDataSlice";

export default configureStore({
    reducer: { cart: cartSlice.reducer, userData: userDataSlice.reducer }
});